module.exports = __webpack_public_path__ + "img/cv.469d1285.png";